import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './web/Home/home.component';
import {StatementsComponent} from './web/statements/Statement/statements.component';
import {StatementsParentComponent} from './web/statements/StatementParent/statements-parent.component';
import {StatementsStoresComponent} from './web/statements/StatementStores/statement-stores.component';
import {InvoicesComponent} from './web/invoices/Invoices/invoices.component';
import {StatementsInvoicesComponent} from './web/statements/StatementInvoice/statements-invoices.component';
import {InvoicesStoresComponent} from './web/invoices/InvoicesStores/invoices-stores.component';
import {InvoicesInvoicesComponent} from './web/invoices/InvoicesInvoices/invoices-invoices.component';
import {LogoutComponent} from './web/logout/logout.component';
import {GLGuideMenuComponent} from './web/glguide/glguidemenu.component';
import {AuthGuardService as AuthGuard} from './core/guards/auth-guard.service';
import {RoleGuardService as RoleGuard} from './core/guards/role-guard.service';
import {paths} from './app-paths';
import {PathResolveService} from './core/services/path-resolve.service';
import {NotFoundComponent} from './web/not-found/not-found.component';
import {NoAccessComponent} from './web/not-found/no-access.component';
import {Error500Component} from './web/not-found/error-500.component';
import {ChallengeComponent, ChallengeGuard} from 'mclane-webauth-lib';
// @ts-ignore
import {SettingsComponent} from 'mclane-apptemplate-lib';
import {InvoiceProcessingComponent} from './web/accounting/accounts-payable/invoice-processing/invoice-processing.component';
import {ItemsPostingComponent} from './web/accounting/accounts-payable/items-posting/items-posting.component';
import {ItemGlSetupComponent} from '~/app/web/setup/item-gl-setup/item-gl-setup.component';
import {ItemGlDetailsComponent} from '~/app/web/setup/item-gl-details/item-gl-details.component';
import {StoreApGlXrefComponent} from '~/app/web/setup/store-ap-gl-xref/store-ap-gl-xref.component';
import {ItemSetupComponent} from '~/app/web/setup/item-setup/item-setup.component';
import {StoreConfigComponent} from '~/app/web/setup/store-config/store-config.component';
import {GlCodesSetupTemplateComponent} from '~/app/web/setup/gl-codes-setup-template/gl-codes-setup-template.component';
import {HierarchyContainerComponent} from "~/app/web/setup/hierarchy/containers/hierarchy.container";
import {ReportsComponent} from '~/app/web/reports/reports.component';
import {ReportAccessComponent} from "~/app/web/user-admin/components/report-access/report-access.component";
import {StoreAccessComponent} from "~/app/web/user-admin/components/store-access/store-access.component";
import {StoreReportGroupingComponent} from "~/app/web/setup/store-report-grouping/store-report-grouping.component";


export const appRoutes: Routes = [

  {
    path: paths.home,
    component: HomeComponent,
    canActivate: [AuthGuard, ChallengeGuard],
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: paths.statements,
    component: StatementsComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Statements: Search',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.accountspayable,
    component: InvoiceProcessingComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Invoice Processing',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.itemsPosting,
    component: ItemsPostingComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Items Posting To Default',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.itemGlSetup,
    component: ItemGlSetupComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Item GL Setup',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.itemSetup,
    component: ItemSetupComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Item Setup',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.itemGlDetails,
    component: ItemGlDetailsComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Item GL Details',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.storeApGLXref,
    component: StoreApGlXrefComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Store AP GL Xref',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.storeConfig,
    component: StoreConfigComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Store Config',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.statementparents,
    component: StatementsParentComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Statements: Select Parent(s)',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.invoices,
    component: InvoicesStoresComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Invoices: Select Store(s)',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.invoicesearch,
    component: InvoicesComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Invoices: Search',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.statementstores,
    component: StatementsStoresComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Statements: Select Store(s)',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.statementinvoices,
    component: StatementsInvoicesComponent,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    data: {
      text: 'Statement: Select Invoice(s)',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.invoiceinvoices,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    component: InvoicesInvoicesComponent,
    data: {
      text: 'Invoices: Select Invoice(s)',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.glguidemenu,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    component: GLGuideMenuComponent,
    data: {
      text: 'GL Guide Menu',
      expectedRole: 'Login_User_GL'
    }
  },
  {
    path: paths.glCodesSetupTemplate,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    component: GlCodesSetupTemplateComponent,
    data: {
      text: 'GL Codes Setup Template',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.hierarchy,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    component: HierarchyContainerComponent,
    data: {
      text: 'Hierarchy',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.reports,
    canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
    component: ReportsComponent,
    data: {
      text: 'Reports',
      expectedRole: 'AP_Export'
    }
  },
  {
    path: paths.reportAccess,
    canActivate: [AuthGuard, ChallengeGuard],
    component: ReportAccessComponent,
    data: {
      text: 'Report Access',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.storeAccess,
    canActivate: [AuthGuard, ChallengeGuard],
    component: StoreAccessComponent,
    data: {
      text: 'Store Access',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: paths.storeReportGrouping,
    canActivate: [AuthGuard, ChallengeGuard],
    component: StoreReportGroupingComponent,
    data: {
      text: 'Store Report Grouping',
      expectedRole: 'Login_User_Default'
    }
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    component: SettingsComponent,
  },
  {
    path: 'challenge',
    canActivate: [AuthGuard],
    component: ChallengeComponent,
  },
  {
    path: paths.logout,
    component: LogoutComponent,
    data: {text: 'Logout'}
  },
  {
    path: paths.access_denied,
    component: NoAccessComponent
  },
  {
    path: paths.error500,
    component: Error500Component
  },
  {
    path: '**',
    resolve: {
      path: PathResolveService
    },
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    appRoutes,
    { enableTracing: false }
  )],
  exports: [RouterModule]
})

export class AppRoutingModule {

}


